import type { Environment } from './allowlist';

export interface BridgeConfig {
  env: Environment;
  firebase: {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
  };
}

const DEV_CONFIG: BridgeConfig = {
  env: 'dev',
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? '',
    authDomain: 'auth.dev.ondeo.store',
    projectId: 'stone-citizen-481316-n4',
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? '',
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? '',
    appId: import.meta.env.VITE_FIREBASE_APP_ID ?? '',
  },
};

const PROD_CONFIG: BridgeConfig = {
  env: 'prod',
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? '',
    authDomain: 'auth.themarquee.ai',
    projectId: 'marquee-multitenant-prod',
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? '',
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? '',
    appId: import.meta.env.VITE_FIREBASE_APP_ID ?? '',
  },
};

export function getBridgeConfig(): BridgeConfig {
  const target = import.meta.env.VITE_BRIDGE_ENV;
  if (target === 'prod') return PROD_CONFIG;
  return DEV_CONFIG;
}
